/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Event_Is_Over_DescriptionInputs */

const en_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay tuned for our next exciting event!`)
};

const ar_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترقبوا فعاليتنا المثيرة القادمة!`)
};

const de_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleiben Sie dran für unser nächstes spannendes Event!`)
};

const es_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Permanece atento a nuestro próximo evento!`)
};

const fr_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne manquez pas notre prochain événement qui s'annonce extraordinaire !`)
};

const it_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resta sintonizzato per il nostro prossimo evento entusiasmante!`)
};

const ja_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次回のイベントにご期待ください！`)
};

const ko_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 이벤트를 기대해 주세요!`)
};

const pt_br_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fique de olho no nosso próximo evento!`)
};

const ru_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следите за нашим следующим захватывающим событием!`)
};

const th_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดติดตามอีเวนต์ที่น่าตื่นเต้นครั้งต่อไปของเรา!`)
};

const tr_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir sonraki heyecan verici etkinliğimiz için bizi izlemeye devam et!`)
};

const zh_cn_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敬请期待下次的精彩活动！`)
};

const zh_tw_dialog_event_is_over_description = /** @type {(inputs: Dialog_Event_Is_Over_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敬請期待下次的精彩活動！`)
};

/**
* | output |
* | --- |
* | "Stay tuned for our next exciting event!" |
*
* @param {Dialog_Event_Is_Over_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_event_is_over_description = /** @type {((inputs?: Dialog_Event_Is_Over_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Event_Is_Over_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_event_is_over_description(inputs)
	if (locale === "ar") return ar_dialog_event_is_over_description(inputs)
	if (locale === "de") return de_dialog_event_is_over_description(inputs)
	if (locale === "es") return es_dialog_event_is_over_description(inputs)
	if (locale === "fr") return fr_dialog_event_is_over_description(inputs)
	if (locale === "it") return it_dialog_event_is_over_description(inputs)
	if (locale === "ja") return ja_dialog_event_is_over_description(inputs)
	if (locale === "ko") return ko_dialog_event_is_over_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_event_is_over_description(inputs)
	if (locale === "ru") return ru_dialog_event_is_over_description(inputs)
	if (locale === "th") return th_dialog_event_is_over_description(inputs)
	if (locale === "tr") return tr_dialog_event_is_over_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_event_is_over_description(inputs)
	return zh_tw_dialog_event_is_over_description(inputs)
});